import { Box, Flex, Text } from '@chakra-ui/react'
import { Select } from '@/components/Select'
import { WeekStatOption } from '../queries/useUserStats'

type Props = {
  selectedWeek: WeekStatOption | null
  setSelectedWeek: (v: WeekStatOption | null) => void
  weeks: WeekStatOption[]
  loadingWeeks: boolean
}

export default function Filters(props: Props) {
  const {
    selectedWeek,
    setSelectedWeek,
    weeks,
    loadingWeeks,
  } = props

  return (
    <Flex justify="space-between" align="center">
      <Box w="full">
        <Text fontWeight="500" pb="6px">Week</Text>
        <Select
          options={weeks}
          placeholder="Choose a week"
          isClearable
          isSearchable={false}
          isLoading={loadingWeeks}
          value={selectedWeek}
          onChange={(val: WeekStatOption | null) => setSelectedWeek(val)}
        />
      </Box>
    </Flex>
  )
}
